module.exports = __webpack_public_path__ + "img/2_72.0a83f349.png";